
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { StateType } from "./verify";
import { getCodePrimaryInfo, verifyCode } from "../../../../api/production";
import { useRoute } from "vue-router";
import { Dialog } from "vant";

const states = {
  dataInfo: {},
  bgImg: "",
  id: "",
  password: "",
  dataId: "",
};
export default defineComponent({
  setup() {
    const stateData = reactive<StateType>(states);
    const route = useRoute();
    stateData.bgImg = require("../../../assets/icons/imgbg.png");
    onMounted(() => {
      stateData.id = route.query.pid as string;
      stateData.dataId = route.query.dataId as string;
      getCodePrimaryInfo({ codeId: route.query.pid }).then((res: any) => {
        if (res.data.code == 0) {
          stateData.dataInfo = res.data.data;
        }
      });
    });
    return {
      ...toRefs(stateData),
      ...onEvent(stateData),
    };
  },
});
const onEvent = (state: StateType) => {
  const onVerify = async () => {
    const result: any = await verifyCode({
      traceId: state.dataId,
      codeNumber: state.id,
      password: state.password,
    });
    if (result.data.code == 0) {
      Dialog.alert({
        title: "提示",
        message: result.data.msg,
      }).then(() => {
        state.password = "";
      });
    } else {
      Dialog.alert({
        title: "提示",
        message: result.data.msg,
      }).then(() => {
        state.password = "";
      });
    }
  };
  return {
    onVerify,
  };
};
